import { ParallaxTextProps } from '../../../types/ParallaxTextTypes';

const appCloudParallaxText: ParallaxTextProps = {
  leftTitle: '',
  leftText: '',
  rightTitle: '',
  rightText: '',
};

export default appCloudParallaxText;